if (!customElements.get('image-fader')) {
  customElements.define(
    'image-fader',
    class ImageFader extends HTMLElement {
      
      constructor() {
        super();
        
        this.images = this.querySelectorAll('img');
        
        if (this.images && this.images.length > 1) {
          
          this.imageCount = this.images.length;
          this.activeClass = 'active';
          this.delay = 6000;
          this.speed = 4000;
          this.currentImage = 0;
          
          // handle passed values
          const passedDelay = parseInt(this.dataset.delay);
          const passedSpeed = parseInt(this.dataset.speed);
          if (Number.isInteger(passedDelay) && passedDelay > 0) {
            this.delay = passedDelay;
          }
          if (Number.isInteger(passedSpeed) && passedSpeed > 0) {
            this.speed = passedSpeed;
          }
          
          // start fader loop
          this.faderLoop(this);
        }
      }
      
      faderLoop(firstLoop) {
        
        // shorter delay first time through the loop
        let delay = this.delay;
        if (firstLoop) {
          delay = this.delay - (this.speed / 2);
        }
        
        // switch image after delay
        setTimeout(() => {
          
          // deactivate current image
          this.images[this.currentImage].classList.remove(this.activeClass);
          
          // change index
          if (++this.currentImage >= this.imageCount) this.currentImage = 0;
          
          // activate current image
          this.images[this.currentImage].classList.add(this.activeClass);
          
          // repeat
          this.faderLoop();
          
        }, delay);
      }
    }
  );
}
